import React from 'react';

interface ScanBranchCellProps {
  branches?: string[];
}

/**
 * Branch column for the scans table, shared by completed and running rows.
 *
 * A batch spans one branch per repository, so it shows the first and counts the
 * rest. The column shrinks to its content (`w-px`), so a long branch name is
 * truncated rather than allowed to squeeze the columns beside it.
 */
const ScanBranchCell: React.FC<ScanBranchCellProps> = ({ branches = [] }) => {
  const [primaryBranch, ...otherBranches] = branches;

  return (
    <td className="w-px whitespace-nowrap py-3.5 px-4 align-middle">
      {primaryBranch ? (
        <span className="flex items-baseline gap-1 font-mono text-xs text-ui-text-secondary">
          <span className="max-w-[14rem] truncate" title={branches.join(', ')}>
            {primaryBranch}
          </span>
          {otherBranches.length > 0 && (
            <span className="text-ui-text-tertiary" title={branches.join(', ')}>
              +{otherBranches.length}
            </span>
          )}
        </span>
      ) : (
        <span className="text-xs text-ui-text-tertiary">—</span>
      )}
    </td>
  );
};

export default ScanBranchCell;
